import { Caption } from '@collab/atoms';

import { ColorBlockStandalone } from 'atoms/ColorBlock';
import resetMarginsStyle from 'notion/notion.styles';
import { NotionProps } from 'notion/types';

const NotionColorBlockStandalone: React.FC<NotionProps> = ({
  block: { hexColor, caption },
}) => {
  const label = hexColor.includes('rgb') ? hexColor : `HEX ${hexColor}`;

  return (
    <>
      <ColorBlockStandalone
        color={hexColor}
        label={label}
        extend={resetMarginsStyle}
      />
      {caption && <Caption>{caption}</Caption>}
    </>
  );
};

export default NotionColorBlockStandalone;
